export default "__VITE_ASSET__CuT$yWBG__"